export class QTextHeight {
  constructor(fontString, txtHeight, noHangHeight) {
    this.fFontString = fontString;
    this.fTxtHeight = txtHeight;
    this.fHangingOffset = txtHeight - noHangHeight;
  }
}
